/**
 * @generated SignedSource<<f06be0e373134095d73ae5809ea9549c>>
 * @relayHash ba360df9c813e3e6d558edc184fb409f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5bd439fe175f7e5700875f28bf1ecf25bf72ddba2d24d6f059da29f930c75cc2

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentProfileCardContainerQuery$variables = {
  agentAri: string;
  cloudId: string;
  fetchByIdentity: boolean;
  identityAccountId: string;
};
export type AgentProfileCardContainerQuery$data = {
  readonly agentStudio_agentById?: {
    readonly __typename: "AgentStudioAssistant";
    readonly AgentProfileCard_agentRef: {
      readonly " $fragmentSpreads": FragmentRefs<"AgentProfileCard_agentRef">;
    } | null;
    readonly id: string;
    readonly name: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly agentStudio_agentByIdentityAccountId?: {
    readonly __typename: "AgentStudioAssistant";
    readonly AgentProfileCard_agentRef: {
      readonly " $fragmentSpreads": FragmentRefs<"AgentProfileCard_agentRef">;
    } | null;
    readonly id: string;
    readonly name: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AgentProfileCardContainerQuery = {
  response: AgentProfileCardContainerQuery$data;
  variables: AgentProfileCardContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchByIdentity"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "identityAccountId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentAri"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = [
  (v5/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "fragment": {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "AgentProfileCard_agentRef"
            }
          ],
          "type": "AgentStudioAssistant"
        },
        "kind": "AliasedInlineFragmentSpread",
        "name": "AgentProfileCard_agentRef"
      }
    ],
    "type": "AgentStudioAssistant"
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "identityAccountId"
  }
],
v10 = [
  (v5/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v6/*: any*/),
      (v7/*: any*/),
      {
        "kind": "ScalarField",
        "name": "description"
      },
      {
        "kind": "ScalarField",
        "name": "icon"
      },
      {
        "kind": "ScalarField",
        "name": "identityAccountId"
      },
      {
        "kind": "LinkedField",
        "name": "identityAccount",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "externalConfigReference"
      },
      {
        "kind": "ScalarField",
        "name": "isFavourite"
      },
      {
        "kind": "ScalarField",
        "name": "conversationStarters"
      },
      {
        "kind": "ScalarField",
        "name": "creatorType"
      },
      {
        "kind": "ScalarField",
        "name": "forgeCreator"
      },
      {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "accountStatus"
              }
            ],
            "type": "AtlassianAccountUser"
          },
          (v6/*: any*/)
        ]
      },
      {
        "concreteType": "TeamV2",
        "kind": "LinkedField",
        "name": "authoringTeam",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "displayName"
          },
          {
            "kind": "ScalarField",
            "name": "profileUrl"
          },
          (v6/*: any*/)
        ]
      },
      {
        "concreteType": "AgentStudioAgentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canEdit"
          },
          {
            "kind": "ScalarField",
            "name": "canDelete"
          }
        ]
      }
    ],
    "type": "AgentStudioAssistant"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v6/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AgentProfileCardContainerQuery",
    "selections": [
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": (v8/*: any*/)
          }
        ]
      },
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v9/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentByIdentityAccountId",
            "plural": false,
            "selections": (v8/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AgentProfileCardContainerQuery",
    "selections": [
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentById",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      },
      {
        "condition": "fetchByIdentity",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v9/*: any*/),
            "kind": "LinkedField",
            "name": "agentStudio_agentByIdentityAccountId",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5bd439fe175f7e5700875f28bf1ecf25bf72ddba2d24d6f059da29f930c75cc2",
    "metadata": {},
    "name": "AgentProfileCardContainerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7f56b7d6645b9220c953a6792948a3ba";

export default node;
